module.exports = __webpack_public_path__ + "static/media/mh.5b3f8512.jpg";